import { ToggleProps } from "@/components/Inputs/Toggle/ToggleProps.ts";

export const Toggle = (props: ToggleProps) => {
  const { label, registration, checked, id, className } = props;

  const rootClasses = ["c-toggle", checked && "c-toggle--checked", className].filter(Boolean).join(" ");

  return (
    <label className={rootClasses} htmlFor={id || registration.name}>
      <input type="checkbox" {...registration} id={id || registration.name} className="c-toggle__input" />
      <span className="c-toggle__track">
        <span className="c-toggle__thumb" />
      </span>
      <span className="c-toggle__label">{label}</span>
    </label>
  );
};
